import { z } from 'zod'

export const AdminK8sTenantStatus = z.enum([
  'provisioning',
  'active',
  'failed',
  'deprovisioning',
  'deprovisioned'
])
export type AdminK8sTenantStatus = z.infer<typeof AdminK8sTenantStatus>

export const AdminK8sTenantListItem = z.object({
  id: z.number().int(),
  namespace: z.string(),
  status: AdminK8sTenantStatus,
  error_message: z.string().nullable().optional(),
  provisioned_at: z.number().nullable().optional(),
  created_at: z.number(),
  account_id: z.number().int(),
  account_email: z.string(),
  product_name: z.string().optional(),
  git_repo_url: z.string().nullable().optional(),
  self_heal: z.boolean()
})
export type AdminK8sTenantListItem = z.infer<typeof AdminK8sTenantListItem>

export const AdminK8sUsageOverviewItem = z.object({
  account_id: z.number().int(),
  account_email: z.string(),
  namespace: z.string(),
  cpu_core_hours: z.number(),
  memory_gib_hours: z.number(),
  storage_gib: z.number(),
  egress_gib: z.number(),
  projected_total_cents: z.number(),
  spending_cap_cents: z.number().nullable().optional()
})
export type AdminK8sUsageOverviewItem = z.infer<typeof AdminK8sUsageOverviewItem>

export const AdminK8sDomainListItem = z.object({
  id: z.number().int(),
  domain: z.string(),
  verified: z.boolean(),
  verified_at: z.number().nullable().optional(),
  verification_token: z.string(),
  created_at: z.number(),
  account_id: z.number().int(),
  account_email: z.string()
})
export type AdminK8sDomainListItem = z.infer<typeof AdminK8sDomainListItem>
